import React from 'react';
import { Stack, Typography } from '@mui/material';
import PropTypes from 'prop-types';
import DigitalSensorValue from '../DigitalSensorValue';
import { readingPropTypes } from '../ActuatorControl/types';

const hiddenValueModes = ['digital'];

const ActuatorFeatureState = ({ reading }) => {
  const { value, unit, threshold, measuring_mode } = reading;

  const shouldDisplayValue = !hiddenValueModes.includes(measuring_mode);

  return (
    <Stack flexDirection="row" gap="0.25rem" alignItems="baseline">
      {shouldDisplayValue && (
        <Typography
          variant="body1"
          fontWeight={value !== '-' ? 'bold' : 'unset'}
          color="#f5f5f5"
        >
          {value}
        </Typography>
      )}
      {unit && (
        <Typography variant="body1" fontSize="0.75rem" color="#e3e3e3">
          {unit}
        </Typography>
      )}

      {measuring_mode === 'digital' && (
        <DigitalSensorValue binarySensor={threshold[value]} colorized />
      )}
    </Stack>
  );
};

ActuatorFeatureState.defaultProps = {
  reading: {},
};

ActuatorFeatureState.propTypes = {
  reading: PropTypes.shape(readingPropTypes),
};

export default ActuatorFeatureState;
